<div class="card mb-5" [style.margin-left]="data.marginleft" *ngIf="data">
  <div class="card-header" style="border-bottom: none; padding: 4px 6px;">
    <div class="card-title d-flex flex-column">
      <h6 style="margin: 0; font-size: calc(16px * var(--dvm-font-scale, 1));"
        [style.text-align]="data.titleAlignment || 'center'">
        {{ data.title }}
      </h6>
    </div>
  </div>

  <div class="card-body" style="padding: 4px; position: relative;">
    <div class="legend-wrapper" *ngIf="legendItems.length > 0">
      <button class="scroll-arrow" *ngIf="showLeftArrow" (click)="scrollLegend('left')">
        &lsaquo;
      </button>

      <div #legendContainer class="custom-legend-container" [ngClass]="{ 'center-legends': legendItems.length <= 3 }"
        (scroll)="updateArrowVisibility()">
        <div class="legend-item" *ngFor="let item of legendItems" (click)="onLegendItemClick(item.name)"
          [style.cursor]="'pointer'"
          [style.opacity]="selectedLegends.length > 0 && !selectedLegends.includes(item.name) ? 0.3 : 1">
          <span class="legend-color-box" [style.background]="item.color"></span>
          <span class="legend-label">{{ item.name }}</span>
        </div>
      </div>

      <button class="scroll-arrow" *ngIf="showRightArrow" (click)="scrollLegend('right')">
        &rsaquo;
      </button>
    </div>

    <div #chartContainer [id]="data.widgetId" style="width: 100%;"
      [style.height]="data.height || 'var(--dvm-chart-height, 300px)'"></div>

    <div class="scrollbar-track horizontal" *ngIf="allCategories.length > maxVisibleCategories">
      <div class="scrollbar-thumb horizontal" [style.width.px]="getScrollbarThumbWidth()"
        [style.left.px]="getScrollbarThumbLeft()" (mousedown)="onScrollbarMouseDown($event)"></div>
    </div>
  </div>
</div>
